export const PATIENT_ACCOUNT_TYPE = 'patient';

export const emptyPatientSignupFields = {
  patientFirstName: '',
  patientMiddleName: '',
  patientLastName: '',
  patientDob: '',
  patientPhone: '',
};

export function validatePatientSignupFields(fields, email) {
  if (!String(fields?.patientFirstName || '').trim()) return 'First name is required.';
  if (!String(fields?.patientLastName || '').trim()) return 'Last name is required.';
  if (!String(fields?.patientDob || '').trim()) return 'Date of birth is required.';
  if (!String(fields?.patientPhone || '').trim()) return 'Phone number is required.';
  if (!String(email || '').trim()) return 'Email is required.';
  return null;
}

export function buildPatientSignupFields(fields, email) {
  return {
    patient_first_name: String(fields?.patientFirstName || '').trim(),
    patient_middle_name: String(fields?.patientMiddleName || '').trim(),
    patient_last_name: String(fields?.patientLastName || '').trim(),
    patient_dob: String(fields?.patientDob || '').trim(),
    patient_phone: String(fields?.patientPhone || '').trim(),
    patient_email: String(email || '').trim(),
  };
}

export function patientDisplayName(fields) {
  return [
    String(fields?.patientFirstName || '').trim(),
    String(fields?.patientLastName || '').trim(),
  ].filter(Boolean).join(' ');
}

export function buildUnauthenticatedSignupPayload({
  userId,
  email,
  name,
  accountType,
  signupReason,
  patientFields,
}) {
  return {
    user_id: userId,
    email,
    name,
    account_type: accountType,
    signup_reason: signupReason,
    patient_fields: accountType === PATIENT_ACCOUNT_TYPE
      ? buildPatientSignupFields(patientFields, email)
      : null,
  };
}
